import styled from "styled-components";
import { DialogTitle, DialogContent, DialogActions } from "@mui/material";

export const StyledDialogTitle = styled(DialogTitle)`
  padding-right: var(--modal-padding-large);
  padding-left: var(--modal-padding-large);
  padding-top: var(--modal-padding-small);

  /* Responsividade para mobile */
  @media only screen and (max-width: 900px) {
    font-size: 1.25rem !important;
  }

  @media only screen and (max-width: 600px) {
    font-size: 1.125rem !important;
  }
`;

export const StyledDialogContent = styled(DialogContent)`
  padding-top: var(--modal-padding-medium);
  padding-bottom: var(--modal-padding-medium);
  padding-left: var(--modal-padding-medium);
  padding-right: var(--modal-padding-medium);
`;

export const StyledDialogActions = styled(DialogActions)`
  padding-left: var(--modal-padding-medium);
  padding-right: var(--modal-padding-medium);
  padding-bottom: var(--modal-padding-medium);
  padding-top: 0;
`;
